var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadInvoicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 119,
    viewBox: "43.5 4 118 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_5146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.3 111.1C52.055 111.1 49.2771 109.935 46.9663 107.604C44.6554 105.274 43.5 102.472 43.5 99.2V15.9C43.5 12.6275 44.6554 9.82604 46.9663 7.49563C49.2771 5.16521 52.055 4 55.3 4H137.9C141.145 4 143.923 5.16521 146.234 7.49563C148.545 9.82604 149.7 12.6275 149.7 15.9V55.765C147.832 54.8725 145.914 54.104 143.948 53.4594C141.981 52.8148 139.965 52.3437 137.9 52.0462V15.9H55.3V99.2H90.995C91.29 101.382 91.7571 103.464 92.3963 105.448C93.0354 107.431 93.7975 109.315 94.6825 111.1H55.3ZM55.3 99.2V15.9V52.0462V51.6V99.2ZM67.1 87.3H91.1425C91.4375 85.2175 91.9046 83.1846 92.5438 81.2012C93.1829 79.2179 93.8958 77.2842 94.6825 75.4H67.1V87.3ZM67.1 63.5H103.09C106.237 60.525 109.752 58.0458 113.636 56.0625C117.52 54.0792 121.675 52.7404 126.1 52.0462V51.6H67.1V63.5ZM67.1 39.7H126.1V27.8H67.1V39.7ZM132 123C123.838 123 116.881 120.099 111.129 114.298C105.376 108.497 102.5 101.481 102.5 93.25C102.5 85.0192 105.376 78.0031 111.129 72.2019C116.881 66.4006 123.838 63.5 132 63.5C140.162 63.5 147.119 66.4006 152.871 72.2019C158.624 78.0031 161.5 85.0192 161.5 93.25C161.5 101.481 158.624 108.497 152.871 114.298C147.119 120.099 140.162 123 132 123ZM129.05 111.1H134.95V96.225H149.7V90.275H134.95V75.4H129.05V90.275H114.3V96.225H129.05V111.1Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_5146"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.5,
    y: 4,
    width: 118,
    height: 119,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadInvoicesIcon);
export default __webpack_public_path__ + "static/media/upload-invoices-icon.9175b383c0b377084a589b13db2429ef.svg";
export { ForwardRef as ReactComponent };